/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Toggle_Failed1Inputs */

const vi_guidevideo_toggle_failed1 = /** @type {(inputs: Guidevideo_Toggle_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được trạng thái hiện / ẩn. Thử lại sau.`)
};

/**

* @param {Guidevideo_Toggle_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_toggle_failed1 = /** @type {((inputs?: Guidevideo_Toggle_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Toggle_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_toggle_failed1(inputs)
});
export { guidevideo_toggle_failed1 as "guideVideo_toggle_failed" }